module.exports = __webpack_public_path__ + "img/solomon-islands.4be6ae9f.svg";